import React, { component } from 'react';

import ButtonV2 from '../button/button_v2';
import Input from '../input/index';
import InputV2 from '../input/input_v2';

import Select from '../select/index';
import StyleModal from './stylesModalFilter1';
import { store } from "react-notifications-component";
import ModalYesNo from './modalYesNo';
import Modal from '.';

import { ContainerContentArtExportar, ModalTitle } from './styles';
import { BodyG, H5 } from '../../styles/stylesTypography';


class ModalNew extends React.Component {
    constructor(props) {
        super(props);
    }

    state = {
        numeroOrdem: '',
        numeroOrdemInicial: '',
        maxNum: '',
        minNum: '',
        showModal: false,
        erroInicial: false,
        erroFinal: false,
    }

    componentDidMount(){
        const numeroOrdemInicial =
            this.props.ordemInicial !== undefined && this.props.ordemInicial !== null
                ? String(this.props.ordemInicial)
                : '';
        const numeroOrdem =
            this.props.ordemFinal !== undefined && this.props.ordemFinal !== null
                ? String(this.props.ordemFinal)
                : '';

        this.setState({
            numeroOrdemInicial,
            numeroOrdem,
            minNum: numeroOrdemInicial,
            maxNum: numeroOrdem,
        });
    }

    confirm = () => {
        // this.setState({ showModal: true });
        this.exportar();
    }


    exportar = async () => {
        let respostaFiltro = this.state.numeroOrdem;
        if(this.state.numeroOrdemInicial && respostaFiltro){
            this.setState({ erroInicial: false, erroFinal: false });
            try {
                await this.props.update(this.state.numeroOrdemInicial, respostaFiltro);
            } catch {
                this.setState({ erroInicial: true, erroFinal: true });
            }
        }else{
            this.setState({
                erroInicial: !this.state.numeroOrdemInicial,
                erroFinal: !respostaFiltro,
            });

            store.addNotification({
                title: "Erro!",
                message: `Informe a faixa desejada de número de ordem`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }

    // modalClose = () => {
    //     if(this.state.showModal == true){
    //         this.setState({ showModal: false });
    //     }
    // }

    // updateResposta = resposta => {
    //     if(resposta == 1){
    //         this.exportar();
    //         this.modalClose();
    //     }else{
    //         this.props.onHide();
    //     }
    // }
    

    render() {
        return (

            // <Modal
            //     {...this.props}
            //     size="lg"
            //     aria-labelledby="contained-modal-title-vcenter"
            //     centered
            // >
            //     <Modal.Header closeButton>
            //         <Modal.Title id="contained-modal-title-vcenter">
            //             {this.props.title} {this.props.option}
            //         </Modal.Title>
            //     </Modal.Header>


            //     <Modal.Body>
            //         <StyleModal>

            //             <label style={{ fonSize: "small" }}>Informe a faixa desejada do número de ordem para exportar o arquivo CREA</label>

            //             <Input
            //                 placeholder="Número de ordem inicial"
            //                 value={this.state.numeroOrdemInicial}
            //                 onChange={e => this.setState({ numeroOrdemInicial: e.target.value })}
            //                 type="number"
            //                 max={this.state.maxNum}
            //                 min={this.state.numeroOrdemInicial}
            //                 id="inicial"
                            
            //                 >
            //             </Input>
            //             <Input
            //                 // label="Número de ordem"
            //                 // placeholder="Número de ordem"
            //                 placeholder="Número de ordem final"
            //                 // value={this.state.numeroOrdemInicial}
            //                 onChange={e => this.setState({ numeroOrdem: e.target.value })}
            //                 type="number"
            //                 min={this.state.numeroOrdemInicial}
            //                 max={this.state.maxNum}
            //                 id="final"
                            
            //                 >
            //             </Input>
            //         </StyleModal>

            //     </Modal.Body>

            //     <Modal.Footer>
            //         <div className="footer" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            //             <label style={{ fontSize: "medium", fontWeight: "700", width: "70%", textAlign: 'center' }}>A responsabilidade pelo envio dos dados para as defesas agropecuárias é do usuário. Tem certeza de que deseja gerar o arquivo?</label>

            //             <Button style={{outline:0, padding: "15px", height: '46px'}}
            //                 outline
            //                 color="#00b43f"
            //                 onClick={() => this.confirm()}
            //             >Exportar</Button>
            //         </div>

            //     </Modal.Footer>
            // </Modal>


            <Modal
                {...this.props}
                align='center' // center, end, start
                justify='center' // center, end, start
                responsive
                width='50%'
                maxWidth='680px'
            >
                <ModalTitle>
                    <H5>
                        {this.props.title} {this.props.option}
                    </H5>
                </ModalTitle>

                <ContainerContentArtExportar>
                    <BodyG>Informe a faixa desejada do número de ordem para exportar o arquivo CREA.</BodyG>

                    <InputV2
                        labelWithAsterisk={true}
                        label="Número de ordem inicial"
                        value={this.state.numeroOrdemInicial}
                        onChange={value => this.setState({ numeroOrdemInicial: value, erroInicial: false })}
                        type="number"
                        max={this.state.maxNum}
                        min={this.state.numeroOrdemInicial}
                        id="inicial"
                        height='auto'
                        minHeight='auto'
                        marginBottom='0px'
                        erro={this.state.erroInicial}
                     />

                    <InputV2
                        labelWithAsterisk={true}
                        label="Número de ordem final"
                        value={this.state.numeroOrdem}
                        onChange={value => this.setState({ numeroOrdem: value, erroFinal: false })}
                        type="number"
                        min={this.state.numeroOrdemInicial}
                        max={this.state.maxNum}
                        id="final"
                        height='auto'
                        minHeight='auto'
                        erro={this.state.erroFinal}
                    />
                </ContainerContentArtExportar>

                <div className="footer" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <label style={{ fontSize: "medium", fontWeight: "700", width: "70%", textAlign: 'center' }}>A responsabilidade pelo envio dos dados para as defesas agropecuárias é do usuário. Tem certeza de que deseja gerar o arquivo?</label>

                    <ButtonV2
                        width='110px'
                        height='48px'
                        value="Exportar"
                        onClick={() => this.confirm()}
                    />
                </div>
            </Modal>
        );
    }
}
export default ModalNew;